import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

import MainLayout from 'src/components/layout/MainLayout';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import PastStaysTable from 'src/features/stay/components/PastStaysTable';
import { gatewayMessages } from 'src/features/gatewayPass/utils/messages';
import ActiveStaysTable from 'src/features/stay/components/ActiveStaysTable';
import VisitorsTable from 'src/features/visitor/components/VisitorsTable';
import GatewayPassesTable from 'src/features/gatewayPass/components/GatewayPassesTable';
import EventLogTable from 'src/features/eventLog/components/cell/EventLogTable';

const VisitorsLayout = () => {
    const permissionActiveStays = useHasPermissions([PERMISSION.ACCESS_ACTIVE_STAYS]);
    const permissionPastStays = useHasPermissions([PERMISSION.ACCESS_PAST_STAYS]);
    const accessVisitors = useHasPermissions([PERMISSION.ACCESS_VISITORS]);
    const accessEventLog = useHasPermissions([PERMISSION.ACCESS_EVENT_LOGS]);
    const accessGatewayPasses = useHasPermissions([PERMISSION.ACCESS_GATEWAY_PASSES]);

    const defaultTabsValue = (() => {
        if (permissionActiveStays) return `active-stays`;
        if (permissionPastStays) return `past-stays`;
        if (accessVisitors) return `visitors`;
        if (accessGatewayPasses) return `gateway-passes`;
        if (accessEventLog) return `event-log`;

        return '/no-access';
    })();

    return (
        <MainLayout>
            <Tabs defaultValue={defaultTabsValue}>
                <TabsList>
                    {permissionActiveStays && (
                        <TabsTrigger value="active-stays">
                            <FormattedMessage {...visitorMessages.activeStays} />
                        </TabsTrigger>
                    )}
                    {permissionPastStays && (
                        <TabsTrigger value="past-stays">
                            <FormattedMessage {...visitorMessages.pastStays} />
                        </TabsTrigger>
                    )}
                    {accessVisitors && (
                        <TabsTrigger value="visitors">
                            <FormattedMessage {...visitorMessages.visitors} />
                        </TabsTrigger>
                    )}
                    {accessGatewayPasses && (
                        <TabsTrigger value="gateway-passes">
                            <FormattedMessage {...gatewayMessages.gatewayPasses} />
                        </TabsTrigger>
                    )}
                    {accessEventLog && (
                        <TabsTrigger value="event-log">
                            <FormattedMessage {...gatewayMessages.eventLog} />
                        </TabsTrigger>
                    )}
                </TabsList>
                {permissionActiveStays && (
                    <TabsContent value="active-stays">
                        <ActiveStaysTable />
                    </TabsContent>
                )}
                {permissionPastStays && (
                    <TabsContent value="past-stays">
                        <PastStaysTable />
                    </TabsContent>
                )}
                {accessVisitors && (
                    <TabsContent value="visitors">
                        <VisitorsTable />
                    </TabsContent>
                )}
                {accessGatewayPasses && (
                    <TabsContent value="gateway-passes" className="w-full">
                        <GatewayPassesTable isHomeScreen />
                    </TabsContent>
                )}
                {accessEventLog && (
                    <TabsContent value="event-log" className="w-full">
                        <EventLogTable />
                    </TabsContent>
                )}
            </Tabs>
            <Outlet />
        </MainLayout>
    );
};

export default VisitorsLayout;
